import React, { useState } from "react";
import styled from "styled-components";

import { Text } from "../../TextConstants";
import { Colors } from "../../ColorConstants";
import { OptionCheck } from "../../assets/icons";

function SlotSelection({ onValueChange }) {
  const [selectedSlot, setSelectedSlot] = useState("");
  const [optionDisplay, setOptionDisplay] = useState(true);

  const toggle = () => {
    const newValue = !optionDisplay;
    setOptionDisplay(newValue);
    onValueChange(newValue);
  };
  const setSlot = (value) => {
    setSelectedSlot(value);
  };
  const close = () => {
    setOptionDisplay(true);
    console.log("ajshdsjahd");
  };
  const slots = [
    "Morning (10AM - 12PM)",
    "Afternoon (12PM - 3PM)",
    "Evening (3PM - 6PM)",
  ];
  return (
    <SlotContainer>
      <Title>{Text.slotSelectionTitle}</Title>
      <SlotSelectContainer>
        <SelectedSlot onClick={toggle}>
          {selectedSlot}
          <OptionContainer disabled={optionDisplay}>
            <Option
              onClick={() => setSlot(slots[0])}
              selected={selectedSlot === slots[0]}
            >
              {slots[0]}
              <Tick selected={selectedSlot === slots[0]}></Tick>
            </Option>
            <Option
              onClick={() => setSlot(slots[1])}
              selected={selectedSlot === slots[1]}
            >
              {slots[1]}
              <Tick selected={selectedSlot === slots[1]}></Tick>
            </Option>
            <Option
              onClick={() => setSlot(slots[2])}
              selected={selectedSlot === slots[2]}
            >
              {slots[2]}
              <Tick selected={selectedSlot === slots[2]}></Tick>
            </Option>
          </OptionContainer>
        </SelectedSlot>
      </SlotSelectContainer>

      {/* {error && <ErrorHelperText>{error}</ErrorHelperText>} */}
    </SlotContainer>
  );
}

const ErrorHelperText = styled.div`
  font-size: 0.75rem;
  color: red;
`;

const SlotContainer = styled.div`
  width: 100%;
`;

const Title = styled.div`
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
`;

const SlotSelectContainer = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
  position: relative;
`;
const SelectedSlot = styled.div`
  position: relative;
  border-bottom: 1px solid ${Colors.grey40};
  border-top: none;
  border-left: none;
  border-right: none;
  height: 2rem;
  width: 100%;
  outline: none;
  background: none;
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;

  &::placeholder {
    color: ${Colors.lightBlack};
    font-weight: 500;
  }
`;

const OptionContainer = styled.div`
  position: absolute;
  top: 40px;
  border-radius: 10px;
  background: #efefef;
  display: ${(props) => (props.disabled === true ? "none" : "block")};
  padding-top: 22px;
  z-index: 99;
  width: 100%;
`;

const Option = styled.div`
  margin: 0px 0px 16px 22px;
  font-size: 16px;
  font-style: normal;
  font-weight: ${(props) => (props.selected === true ? "700" : "500")};
  line-height: 22px;
  display: flex;
  align-items: center;

  /* background: #EFEFEF; */
  /* padding: 20px;
  position: absolute;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 1; */
`;

const Tick = styled.div`
  display: ${(props) => (props.selected === true ? "inline-block" : "none")};
  background-image: url(${OptionCheck});
  width: 24px;
  height: 24px;
  margin-left: 16px;
`;

export default SlotSelection;
